"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  _storage: window.sessionStorage,

  /**
   *
   * @return {boolean}
   */
  isSupported: function isSupported() {
    return !!this._storage;
  },

  /**
   *
   * @param name
   * @param value
   * @return {boolean}
   */
  set: function set(name, value) {
    if (!name || !this._storage) {
      return false;
    }

    try {
      this._storage.setItem(name, value);

      return !!this._storage.getItem(name);
    } catch (e) {
      return value;
    }
  },

  /**
   *
   * @param {string} name
   * @return {*}
   */
  get: function get(name) {
    if (!name || !this._storage) {
      return null;
    }

    return this._storage.getItem(name);
  },

  /**
   *
   * @param {string} name
   * @return {boolean}
   */
  remove: function remove(name) {
    if (!name || !this._storage) {
      return false;
    }

    this._storage.removeItem(name);

    return true;
  },

  /**
   *
   * @return {boolean}
   */
  clear: function clear() {
    if (!this._storage) {
      return false;
    } else {
      return this._storage.clear();
    }
  }
};
exports["default"] = _default;